import { render, staticRenderFns } from "./InfoGraphicsDetailPage.vue?vue&type=template&id=6f67b5a6"
import script from "./InfoGraphicsDetailPage.vue?vue&type=script&lang=js"
export * from "./InfoGraphicsDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports